<template>
  <v-chip class="x-small chips pl-2 pr-2" small close @click:close="onClose(name)" :color="chipsColor" :dark="chipsColor === 'black'">
    {{ name }}
  </v-chip>
</template>

<script>
export default {
  name: 'AssetTag',
  props: {
    name: {
      type: String,
    },
    onClose: {
      type: Function,
    },
    chipsColor: {
      type: String,
      default: 'black'
    }
  },
  computed: {
    loading() {
      return this.$store.state.asset.loading;
    }
  }
};
</script>

<style>
</style>